import React, { FC, ReactNode } from "react";
import classNames, { Argument } from "classnames/dedupe";
import { TThemeVariant } from "../../Utility/ThemeProvider/ThemeContext";
import useTheme from "../../Utility/ThemeProvider/useTheme";

export type TPricePosition = "front" | "back";
export type TPriceVariant = "current" | "original" | "content";

export type TPrice = {
  /** Left-side text */
  contentBefore?: ReactNode;
  /** Right-side text */
  contentAfter?: ReactNode;
  /** Position of currency */
  currencyPlace?: TPricePosition;
  /** Text symbol of currency */
  currency: string;
  /** amount / price itself */
  price: string;
  /** Size of text */
  size?: "small" | "default";
  /** Kind of currency - current, original or casual ("content").
   *  Position among several prices is determined by position in prices array, not by variant.
   * */
  variant?: TPriceVariant;
  /** Theme */
  theme?: TThemeVariant;
  classes?: {
    root?: Argument;
  };
};

export interface IPriceProps extends TPrice {
  isHighlighted?: boolean;
}

const Price: FC<IPriceProps> = ({
  classes,
  contentBefore,
  price,
  currency,
  currencyPlace = "front",
  isHighlighted,
  variant = "current",
  size,
  theme: propsTheme,
  contentAfter,
}) => {
  const theme = useTheme(propsTheme);

  return (
    <div
      className={classNames(
        `product-price__${variant}`,
        {
          [`product-price__${variant}--${size}`]:
            size && (!variant || variant === "current"),
          "product-price__current--highlighted":
            variant === "current" && isHighlighted,
          "text-color-white": theme === "dark",
        },
        classes?.root,
      )}
    >
      <span className="text-lowercase">
        {contentBefore}
        {currencyPlace === "front" ? `${currency} ` : null}
        {price}
        {currencyPlace === "back" ? ` ${currency}` : null}
        {contentAfter}
      </span>
    </div>
  );
};

export default Price;
